import React from "react";
import { Link } from "react-router-dom";
import Moment from "react-moment";
import "moment/locale/es";
import getSymbolFromCurrency from "currency-symbol-map";
import { Tag} from "rsuite";
import status from "../../data/status.json";

export const getColumns = (userSetting, t, i18n) => {
    return [
        {
            name: "Id",
            selector: "idTransaction",
            cell: (row) => (
                    row.idTransaction
            ),
        },
        {
            name: t('subscription.templateColumnsSubscription.reference'),
            selector: "referenceNumber",
            wrap: true,
            cell: (row) => (
                    row.referenceNumber
            ),
        },
        {
            name: t('subscription.templateColumnsSubscription.dateAttempt'),
            selector: "transactionDate",
            format: (row) => (
                <Moment locale="es" format="DD/MM/YYYY hh:mm:ss A">
                    {row.transactionDate}
                </Moment>
            ),
            wrap: true,
        },
        {
            name: t('subscription.templateColumnsSubscription.paymentCorrespondingTo'),
            selector: "paymentDate",
            format: (row) => (
                row.paymentDate && (row.idStatus !== 8 && row.idStatus !== 9) ?
                    <Moment locale="es" format="DD/MM/YYYY">
                        {row.paymentDate}
                    </Moment > : ""
            ),
            wrap: true,
        },
        {
            name: t('subscription.templateColumnsSubscription.amount'),
            width: "100px",
            selector: "amount",
            format: (row) =>
                getSymbolFromCurrency(row.currency) +
                row.amount.toLocaleString(userSetting.cultureCode, {
                    minimumFractionDigits: 2,
                }),
        },
        {
            name: t('subscription.templateColumnsSubscription.paymentNumber'),
            selector: "numberOfPayment",
            wrap: true,
        },
        {
            name: t('subscription.templateColumnsSubscription.status'),
            selector: "statusId",
            wrap: true,
            cell: (row) => (
                <span>
                    <Tag color={status[row.idStatus].color}>
                        <div>{i18n.language.includes("es") ? status[row.idStatus].textEs : status[row.idStatus].textEn}</div>
                    </Tag>
                </span>
            ),
        },
    ];
};
